import { Notification03Icon } from '@hugeicons/core-free-icons';
import { Icon } from '../primitives/icon.js';
import * as React from 'react';
import { cn } from '../../lib/cn.js';
import { Button } from '../primitives/button.js';

export interface NotificationButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Unread notifications; 0 hides the counter. */
  count?: number;
}

/** Header bell with an unread counter (count is part of the accessible name). */
export const NotificationButton = React.forwardRef<HTMLButtonElement, NotificationButtonProps>(function NotificationButton({ count = 0, className, ...props }, ref) {
  const label = count > 0 ? `Notificaciones, ${count} sin leer` : 'Notificaciones';
  return (
    <Button ref={ref} variant="ghost" aria-label={label} title={label} className={cn('relative w-10 px-0', className)} {...props}>
      <Icon icon={Notification03Icon} aria-hidden />
      {count > 0 ? (
        <span
          aria-hidden
          className="ef-tabular absolute right-0.5 top-0.5 inline-flex h-4 min-w-4 items-center justify-center rounded-pill bg-danger px-1 text-meta font-semibold leading-none text-text-on-primary"
        >
          {count > 99 ? '99+' : count}
        </span>
      ) : null}
    </Button>
  );
});
